import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { ShieldCheck } from "@phosphor-icons/react";

export default function PrescriberPermissions() {
  const [rows, setRows] = useState([]);
  const load = () => api.get(`/pharmacy/prescribers`).then((r) => setRows(r.data.prescribers)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { document.title = "Izin Resep — HalloGBS"; load(); }, []);

  const toggle = async (u) => {
    try { await api.post(`/pharmacy/prescribers/set`, { user_id: u.id, can_prescribe: !u.can_prescribe }); toast.success(`Izin resep ${!u.can_prescribe ? "diberikan" : "dicabut"} untuk ${u.name || u.email}`); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-5" data-testid="prescriber-permissions">
      <h1 className="flex items-center gap-2 font-heading text-2xl font-extrabold text-[#4C1D95]"><ShieldCheck size={24} weight="duotone" className="text-[#DB2777]" /> Izin Meresepkan</h1>
      <p className="-mt-3 text-sm text-slate-500">Hak meresepkan bersifat <b>eksplisit per akun</b> — tidak ditentukan oleh nama peran. Aktifkan hanya untuk nakes yang berwenang.</p>
      <div className="overflow-x-auto rounded-2xl border border-pink-100 bg-white">
        <table className="w-full min-w-[560px] text-sm">
          <thead className="bg-[#FAF7FF] text-left text-xs text-slate-500"><tr><th className="p-3">Nama</th><th className="p-3">Email</th><th className="p-3">Peran</th><th className="p-3">Izin Resep</th><th className="p-3"></th></tr></thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.id} data-testid={`presc-row-${u.id}`} className="border-t border-pink-50">
                <td className="p-3 font-bold text-slate-800">{u.name || "-"}</td>
                <td className="p-3 text-xs">{u.email}</td>
                <td className="p-3">{u.role}</td>
                <td className="p-3"><span data-testid={`presc-flag-${u.id}`} className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${u.can_prescribe ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-500"}`}>{u.can_prescribe ? "Boleh" : "Tidak"}</span></td>
                <td className="p-3 text-right"><button data-testid={`presc-toggle-${u.id}`} onClick={() => toggle(u)} className={`rounded-lg px-3 py-1.5 text-xs font-bold ${u.can_prescribe ? "bg-rose-50 text-rose-600" : "bg-[#7C4DE0] text-white"}`}>{u.can_prescribe ? "Cabut" : "Beri Izin"}</button></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-slate-400">Belum ada akun nakes.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
